import { useState, useEffect } from 'react';
import MapDisplay from '../components/mapping/MapDisplay';
import { MapProvider } from '../contexts/MapContext';
import { getLineForCustom, getLinesForJourneys, getMarkersForJourneys, getTileLayerForSelectedBackground, getTileLayerForUser, getZoomForCountryCode } from '../utilities/mappingHelper';
import { useSelector } from 'react-redux';

export default function JourneysMap({ journeys, previewPoints, defaultCenter, ...props }) {
    const [mapLines, setMapLines] = useState({ existing: [], preview: [] });
    const [mapPoints, setMapPoints] = useState([]);
    const [mapProps, setMapProps] = useState({ defaultCenter: undefined, tileLayer: undefined });

    const { user } = useSelector((state) => state.auth)
    const { trackForPreview } = useSelector((state) => state.routes)

    useEffect(() => {
        let internalDefaultCenter =  [48.8566, 2.3522]; // Placeholder default if not overwritten by home country or prop
        let internalTileLayer = getTileLayerForSelectedBackground('default');

        if (user) {
            if (defaultCenter) {
                internalDefaultCenter = defaultCenter;
            } else if (user.details.homeCountry) {
                internalDefaultCenter = getZoomForCountryCode(user.details.homeCountry.code);
            }
            
            if (user.preferences.selectedBackground) {
                internalTileLayer = getTileLayerForUser(user);
            }
        } else {
            if (defaultCenter) {
                internalDefaultCenter = defaultCenter;
            }
        }

        setMapProps({
            defaultCenter: internalDefaultCenter,
            tileLayer: internalTileLayer
        });
    }, [user]);

    useEffect(() => {
        setMapLines({
            existing: getLinesForJourneys(journeys, user?.preferences.selectedBackground ? user.preferences.selectedBackground : 'default'),
            preview: []
        });

        setMapPoints(getMarkersForJourneys(journeys, user?.preferences.selectedBackground ? user.preferences.selectedBackground : 'default'));
    }, [journeys]);

    useEffect(() => {
        if (trackForPreview) {
            setMapLines(prevLines => ({
                ...prevLines,
                preview: getLineForCustom(trackForPreview, 'preview')
            }));
        }
    }, [trackForPreview]);

    if (!mapProps.defaultCenter || !mapProps.tileLayer) {
        return null;
    }

    return (
        <MapProvider>
            <MapDisplay
                defaultCenter={mapProps.defaultCenter}
                tileLayer={mapProps.tileLayer}

                lines={mapLines}
                points={mapPoints}
                previewPoints={previewPoints}

                {...props}
            />
        </MapProvider>
    );
};
